import axios from 'axios/index';

export const isStatus = status => handler => response => {
  if (response.status === status) {
    return handler ? handler(response) : response;
  }
};

export const isStatusError = status => handler => error => {
  if (error.response && error.response.status === status) {
    return handler(error);
  }

  throw error;
};

export const is200Status = isStatus(200);

export default class ApiRequest {
  constructor(baseURL, version = 1) {
    this.baseURL = baseURL;
    this.version = version;
    this.token = localStorage.getItem('token') || '';
  }

  buildConfig(method, url, data, responseType = 'json') {
    const config = {
      method,
      data,
      responseType,
      url: `/api/v${this.version}/${url}`,
      baseURL: this.baseURL,
    };

    if (this.token) {
      config.headers = {
        'X-API-TOKEN': this.token,
      };
    }

    return config;
  }

  makeRequest(method, url, data, responseType = 'json') {
    return axios(this.buildConfig(method, url, data, responseType)).catch(error => {
      console.error(error);

      throw error;
    });
  }

  get(url, data, responseType = 'json') {
    return this.makeRequest('get', url, data, responseType);
  }

  post(url, data) {
    return this.makeRequest('post', url, data);
  }

  patch(url, data) {
    return this.makeRequest('patch', url, data);
  }

  delete(url) {
    return this.makeRequest('delete', url);
  }

  setToken(token) {
    this.token = token;
  }
}

export class ApiError extends Error {
  constructor(error) {
    super(error.message);
    this.error = error;
  }
}



// WEBPACK FOOTER //
// ./src/api/apiRequest.js